<template>
  <div class="foot-section">
    <div class="foot-social">
      <a v-for="link in socialLinks" :key="link.name" :href="link.href" target="_blank">
        <img :src="imgUrlPrefix + link.img + '.png'" :alt="link.label" :class="link.label === 'TikTok' ? 'tk' : ''" />
      </a>
    </div>
    <div class="foot-copyright">
      <span>ICP备案/许可证号：沪ICP备17004675号</span>{{ isMobile ? '' : '｜'}}
      <a href="" target="_blank">免责声明</a>｜
      <a href="" target="_blank">用户隐私协议</a>
    </div>
  </div>
</template>

<script>
import { checkIsMobile } from '../utils/tools.js'
export default {
  name: "FootComponent",
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice)
  },
  data() {
    return {
      isMobile: false,
      imgUrlPrefix: '/assets/images/footer/', // 图片地址前缀
      socialLinks: [
        { name: '小红书',  href: 'https://www.xiaohongshu.com/user/profile/66a334ae000000001d0325da?xsec_token=YBfZluVPtvlAdlZHuWaWm6T1d0r5dph5YiewzrThYKv94=&xsec_source=app_share&xhsshare=CopyLink&shareRedId=N0g4Qkk3PUE4OEZFQEwwNjY0QD9HOkxC&apptime=1776735833&share_id=92ab9b71b3f54ca98f8c1ae863e2ec02',       img: 'icon-xiaohongshu',     label: '小红书' },
        { name: '抖音', href: 'https://v.douyin.com/jqTebROw2pI/',            img: 'icon-douyin',     label: '抖音' },
        { name: '微信', href: 'https://mp.weixin.qq.com/s/Q06q2l1GBlr4k4mIunc2iA',            img: 'icon-wechat',     label: '微信' },
        { name: '视频号',  href: 'https://channels.weixin.qq.com',     img: 'icon-shipinhao',     label: '视频号' },
        // { name: 'bilibili', href: 'https://www.bilibili.com',         img: 'icon-bilibili',     label: 'B站' },
        // { name: 'TikTok',   href: 'https://www.tiktok.com',           img: 'icon-tiktok',     label: 'TikTok' },
        // { name: '公众号',  href: 'https://mp.weixin.qq.com',           img: 'icon-gongzhonghao',      abel: '公众号' },
        // { name: 'Weibo',    href: 'https://weibo.com',                 img: 'icon-weibo',     label: '微博' },
        // { name: 'YouTube',  href: 'https://www.youtube.com',           img: 'icon-YouTube',     label: 'YouTube' },
        // { name: 'Instagram',href: 'https://www.instagram.com',         img: 'icon-instagram',     label: 'Instagram' },
        // { name: 'Facebook', href: 'https://www.facebook.com',          img: 'icon-facebook',   label: 'Facebook' },
        // { name: 'Twitch',   href: 'https://www.twitch.tv',             img: 'icon-twitch',     label: 'Twitch' },

      ]
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = checkIsMobile()
    },
  }
}
</script>

<style lang="less" scoped>
.foot-section {
  width: 100%;
  aspect-ratio: 1920 / 276; 
  background-color: #000;
  overflow: hidden;
  font-family: 'TsangerYunHei', sans-serif;
  font-weight: @fw2;
  .foot-social {
    display: flex;
    justify-content: center;
    margin: 4.17vw auto 2.08vw;
    a {
      width: auto;
      height: 2.73vw;
      display: flex;
      align-items: center;
      margin-right: 4vw;
      img {
        height: 100%;
        width: auto;
        &.tk {
          height: 71%;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .foot-copyright {
    font-size: 16px;
    color: 'rgba(255,255,255,0.5)';
    text-align: center;
    a {
      transition: color 0.2s;
      &:hover {
        color: #fff;
      }
    }
  }
}
@media (max-width: @mobile-width) {
  .foot-section {
    aspect-ratio: auto;
    padding: 13.87vw 5.87vw;
    .foot-social{
      justify-content: start;
      margin: 0;
      padding-bottom: 4.8vw;
      border-bottom: 1px solid rgba(255,255,255,0.15);
      a {
        width: auto;
        height: 9.6vw;
        display: flex;
        align-items: center;
        margin-right: 13.87vw;
        img {
          height: 100%;
          width: auto;
          &.tk {
            height: 71%;
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .foot-copyright {
      font-size: 3.2vw;
      text-align: left;
      width: 56.8vw;
      margin-top: 3.2vw;
    }
  }
  
}
</style>